import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { OidcSecure } from '@axa-fr/react-oidc';
import Header from './Header';
import './Layout.scss';
import Footer from './Footer';
import LeftSideMenu from './LeftSideMenu';
// eslint-disable-next-line import/order
import { Container, Fade } from 'react-bootstrap';
import UserValidate from './UserValidate';

const propTypes = {
  plain: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
const defaultProps = {
  plain: false,
  children: {},
};

export default function Layout(props = { plain: false, children: {} }) {
  const [title, setTitle] = useState('');
  const [fadeIn, setFadeIn] = useState(false);
  setTimeout(() => setFadeIn(true), 1);

  useEffect(() => {
    setTimeout(() => setFadeIn(true), 200);
  }, [fadeIn]);

  return (
    <div className="main-contents animated animate__fadeIn animate__slower">
      {!props.plain && (
        <OidcSecure>
          <Header />
          <Container fluid>
            <div className="main-container">
              <UserValidate>
                <Fade in={fadeIn}>
                  <h1 className="page-title d-xl-block d-lg-block d-sm-block d-sm-none">
                    {title}
                  </h1>
                </Fade>
                <div className="row">
                  <div className="left-contents col-lg-2 col-md-2 pe-xl-4 pe-lg-4 pe-md-4 d-xl-block d-lg-block d-sm-block p-sm-0 mb-sm-3">
                    <LeftSideMenu
                      onChange={(e) => {
                        setTitle(e);
                        setFadeIn(false);
                      }}
                    />
                  </div>
                  <div className="right-contents col-lg-10 col-md-10 ps-xl-4 ps-lg-4 ps-md-4 p-sm-0">
                    {props?.children}
                  </div>
                </div>
              </UserValidate>
            </div>
          </Container>
          <Footer />
        </OidcSecure>
      )}
      {props.plain && (
        <Container className="mt-5" data-testid="Wrapper-plain">
          {props?.children}
        </Container>
      )}
    </div>
  );
}

Layout.propTypes = propTypes;
Layout.defaultProps = defaultProps;
